import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Desktop, Mobile } from '../../../App';
import { Flexed, SectionSeparator } from '../../../styles/GlobalComponents';
import { FlexCenter, FlexEnd } from '../../../styles/stylesStyled';
import { LevelZero } from '../common/desktop';
import { getLevels } from '../myTeamBackOffice.actions';
import {
  FlexJustifyCenter,
  GenerationsDate,
  GenerationsDesktop,
  GenerationsInfo
} from '../MyTeamBackofficeStyled';
import UserComponent from '../UserComponent';
import Generation from './Generation';
import { DisplayText, P1, P2, P3 } from '../../../styles/FontStyles';
import { colors } from '../../../styles/GlobalStyles';
import { CaptionText } from '../../../styles/FontStyles';

const Generations = ({ tab }) => {
  const { t } = useTranslation('myTeam');
  const { user } = useSelector((state) => state.auth.userInfo);
  const { userAsTeamMember, userAsTeamMemberInfo, levels } = useSelector(
    (state) => state.myTeamBackoffice
  );

  const dispatch = useDispatch();
  useEffect(() => {
    if (!levels) dispatch(getLevels());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FlexJustifyCenter
        style={{ flexDirection: 'column', alignItems: 'center' }}>
        <Desktop style={{ width: '100%' }}>
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
            <LevelZero
              teamMember={userAsTeamMember}
              teamMemberInfo={userAsTeamMemberInfo}
              tab={tab}
            />

            <Flexed mt='32'></Flexed>
            {levels?.map((level, i) => {
              return (
                <GenerationsDesktop key={i}>
                  <div>
                    <GenerationsDate isLocked={level.isLocked}>
                      <P3
                        bold
                        color={
                          level.isLocked ? colors.neutral400 : colors.neutral0
                        }>{`${t('generations_page.generation')} ${
                        level?.level
                      }`}</P3>{' '}
                      <P1
                        bold
                        color={
                          level.isLocked ? colors.neutral400 : colors.neutral0
                        }>{`${t('generations_page.total')}: ${
                        level.levelUsersCount !== null
                          ? level.levelUsersCount
                          : 0
                      }`}</P1>
                    </GenerationsDate>
                    <GenerationsInfo>
                      <div>
                        <CaptionText semiBold color={colors.neutral700}>
                          {t('generations_page.today')}
                        </CaptionText>
                        <P2
                          bold
                          color={
                            colors.neutral700
                          }>{`+${level.todayChange}`}</P2>
                      </div>
                    </GenerationsInfo>
                    <GenerationsInfo>
                      <div>
                        <CaptionText semiBold color={colors.neutral700}>
                          {t('generations_page.this_week')}
                        </CaptionText>
                        <P2
                          bold
                          color={
                            colors.neutral700
                          }>{`+${level.weekChange}`}</P2>
                      </div>
                    </GenerationsInfo>
                    <GenerationsInfo>
                      <div>
                        <CaptionText semiBold color={colors.neutral700}>
                          {t('generations_page.this_month')}
                        </CaptionText>
                        <P2
                          bold
                          color={
                            colors.neutral700
                          }>{`+${level.monthChange}`}</P2>
                      </div>
                    </GenerationsInfo>
                  </div>
                </GenerationsDesktop>
              );
            })}
          </div>
        </Desktop>

        <Mobile style={{ width: '100%' }}>
          <FlexCenter style={{ flexDirection: 'column' }}>
            <UserComponent user={user} />
          </FlexCenter>

          {/* <SectionSeparator margin={'40px 0'} style={{ maxWidth: '680px' }} /> */}
          {levels?.map((level, i) => {
            return <Generation level={level} key={i} />;
          })}
        </Mobile>
      </FlexJustifyCenter>
    </>
  );
};

export default Generations;
